<template>
  <div class="TicketsUser">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>My Tickets</span>
            </h1>
            <div class="page-header-subtitle" v-if="status!='all'">Support Tickets - {{status}}</div>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <!-- <div class="card-header">DataTable Example</div> -->
              <div class="card-body">
                <vue-good-table
                  :columns="columns"
                  :rows="tickets"
                  :search-options="{
                    enabled: true,
                    trigger: 'enter',
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: 20,
                  }"
                  styleClass="vgt-table condensed myGoodTable"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'ref'">
                      <router-link :to="{name: 'TicketDetailsUser', params: {ref: props.row.ref}}">
                        <b>{{props.row.ref}}</b>
                      </router-link>
                    </span>
                    <span v-if="props.column.field == 'status'">
                      <span v-if="props.row.status.slug == 'open'" class="badge badge-danger">{{props.row.status.name}}</span>
                      <span v-else-if="props.row.status.slug == 'closed'" class="badge badge-success">{{props.row.status.name}}</span>
                      <span v-else-if="props.row.status.slug == 'escalated'" class="badge badge-warning">{{props.row.status.name}}</span>
                    </span>
                    <span v-if="props.column.field == 'categoryName'">{{props.row.category.name}}</span>
                    <span v-if="props.column.field == 'subcategoryName'">{{props.row.subCategory.name}}</span>
                    <span v-if="props.column.field == 'title'">{{props.row.title}}</span>
                    <span v-if="props.column.field == 'userName'">{{props.row.user.name}}</span>
                    <!-- <span v-if="props.column.field == 'agentName'">{{props.row.agent.name}}</span> -->
                    <span v-if="props.column.field == 'createdAt'">{{props.row.createdAt| formatDateTime}}</span>
                  </template>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TicketsUser",

  data() {
    return {
      status: "",
      tickets: [],
      categories: [],
    };
  },

  watch: {
    "$route.params.status": function (status) {
      this.loadTickets(status);
      this.status = status;
      window.scrollTo(0, 0);
    },
  },

  mounted() {
    let status = "all";
    if (this.$route.params.status != undefined) {
      status = this.$route.params.status;
    }
    this.loadTickets(status);
    this.status = status;
  },

  methods: {
    loadTickets(status) {
      let loading = this.$loading.show();
      axios.get("/user/tickets?status=" + status).then((res) => {
        if (res.data.status == "success") {
          this.tickets = res.data.tickets;
        } else {
          //this.$swal("Ooops!", res.data.message, "error");
          this.tickets = [];
        }
        loading.hide();
      });
    },
  },

  computed: {
    columns() {
      let cols = [
        {
          label: "ReferenceID",
          field: "ref",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: this.client.topCategoryLabel,
          field: "categoryName",
        },
        {
          label: this.client.subCategoryLabel,
          field: "subcategoryName",
        },
        {
          label: "Subject",
          field: "title",
        },
        {
          label: "CreatedBy",
          field: "userName",
        },
        /* {
          label: "AssignedTo",
          field: "agentName",
        }, */
        {
          label: "Data/Time",
          field: "createdAt",
        },
      ];
      return cols;
    },

    client() {
      return this.$store.state.client;
    },

    authUser() {
      return this.$store.state.authUser;
    },
  },
};
</script>

